import { observer } from "mobx-react";
import { observable, computed, action, autorun, toJS } from "mobx";
import { config } from "src/config";
import { authStore } from "src/modules/auth/store";

class WidgetStore {

    // public AlertsWidgetPlaceholder: {
    //     loaded: false,
    //     alerts: []
    // }

    @observable
    public AlertsWidget: { [key: string]: any }
    
    constructor() {
        this.AlertsWidget = { loaded: false, alerts: [] };
    }

    @action
    public getAuthAlerts = async (auth_id: number) => {
        const response: Response = await fetch(
            config.BASE_URL + "/api/alert/auth_list/" + auth_id,
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "",
                },
                method: "GET",
            }
        );
        const responseJson = await response.json();
        this.AlertsWidget.alerts = responseJson.body;
        this.AlertsWidget.loaded = true
        // this.layouts = this.mapGridToLayouts(responseJson.body);
    };

    @action
    public authDismissAlert = async (alert_rel_id: number) => {
        const response: Response = await fetch(
            config.BASE_URL + "/api/alert/auth_dismiss_alert/" + alert_rel_id,
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "",
                },
                method: "GET",
            }
        );
        this.AlertsWidget.alerts = this.AlertsWidget.alerts.filter((alert: any) => alert.alert_auth_rel_id !== alert_rel_id)
    }
}

export default new WidgetStore();


// WEBPACK FOOTER //
// ./src/modules/dashboard/widget_store.ts